/**
 * Фиксированная палитра цвета кружка иконки.
 * Первый пункт — прозрачный фон (по умолчанию, как раньше в UI).
 * 24 пункта: прозрачный и 23 цвета из макета Figma (Itten circle), слева направо.
 * Глиф белый. Банки цвет не используют.
 */
export const TRANSPARENT_BG = null;

export const ICON_PALETTE = [
  { id: 'transparent', bg: null, color: null },
  { bg: '#e03e44', color: '#ffffff' },
  { bg: '#f15a29', color: '#ffffff' },
  { bg: '#f1a129', color: '#ffffff' },
  { bg: '#fbd240', color: '#ffffff' },
  { bg: '#e8e100', color: '#ffffff' },
  { bg: '#69c26d', color: '#ffffff' },
  { bg: '#009444', color: '#ffffff' },
  { bg: '#006838', color: '#ffffff' },
  { bg: '#3e908d', color: '#ffffff' },
  { bg: '#498d9b', color: '#ffffff' },
  { bg: '#4fb3e0', color: '#ffffff' },
  { bg: '#1585b1', color: '#ffffff' },
  { bg: '#394ab2', color: '#ffffff' },
  { bg: '#3b3877', color: '#ffffff' },
  { bg: '#662d91', color: '#ffffff' },
  { bg: '#92278f', color: '#ffffff' },
  { bg: '#b43485', color: '#ffffff' },
  { bg: '#ee2aba', color: '#ffffff' },
  { bg: '#da1c7b', color: '#ffffff' },
  { bg: '#ef345a', color: '#ffffff' },
  { bg: '#9e9e9e', color: '#ffffff' },
  { bg: '#5f5f5f', color: '#ffffff' },
  { bg: '#3e3e3e', color: '#ffffff' },
];

export const DEFAULT_ICON_BG = TRANSPARENT_BG;
export const DEFAULT_ICON_COLOR = null;

/** Фон расходной категории, если цвет ещё не выбран. */
export const EXPENSE_ICON_BG = '#e03e44';
/** Фон источника дохода, если цвет ещё не выбран. */
export const INCOME_ICON_BG = '#009444';
export const ICON_GLYPH = '#ffffff';

/**
 * Явно сохранённый прозрачный фон. Пустая строка и null — это «ещё не выбирали»,
 * для категорий клиент подставляет красный или зелёный.
 */
export function isExplicitTransparent(bg) {
  if (bg == null || bg === '') return false;
  const v = String(bg).trim().toLowerCase();
  return v === 'transparent' || v === 'none';
}

/**
 * Стиль кружка категории. bank — логотип без заливки.
 * fallback — { bg, color } типа операции.
 */
export function categoryIconStyle(storedBg, fallback, bank = false) {
  if (bank || isExplicitTransparent(storedBg)) return '';
  const pair = (storedBg == null || storedBg === '' || isTransparentBg(storedBg))
    ? fallback
    : colorsForBg(storedBg);
  if (!pair || !pair.bg) return '';
  return `color:${pair.color || ICON_GLYPH};background:${pair.bg};`;
}

/**
 * Значение пикера при открытии формы.
 * null в базе — цвет по умолчанию типа. Строка transparent — выбран прозрачный фон.
 */
export function editingIconBg(storedBg, fallbackBg, bank = false) {
  if (bank || isExplicitTransparent(storedBg)) return null;
  if (storedBg == null || storedBg === '' || isTransparentBg(storedBg)) return fallbackBg;
  return colorsForBg(storedBg).bg;
}

/** Что записать в icon_color / icon_bg. Прозрачный выбор уходит строкой transparent. */
export function iconColorPayload(iconBg, bank = false) {
  if (bank) return { icon_color: null, icon_bg: null };
  if (iconBg == null || isExplicitTransparent(iconBg)) {
    return { icon_color: null, icon_bg: 'transparent' };
  }
  const pair = colorsForBg(iconBg);
  return { icon_color: pair.color, icon_bg: pair.bg };
}

/** Старые значения, которые больше не показываем отдельным кружком. */
const BG_ALIASES = {
  '#e6b325': '#b8860b',
  '#c9920c': '#b8860b',
  '#e67a2e': '#d77300',
};

export function isTransparentBg(bg) {
  if (bg == null || bg === '') return true;
  const v = String(bg).trim().toLowerCase();
  return v === 'transparent' || v === 'none';
}

export function colorsForBg(bg) {
  if (isTransparentBg(bg)) {
    return { bg: null, color: null };
  }
  let hex = String(bg).toLowerCase();
  if (!hex.startsWith('#')) hex = `#${hex}`;
  if (BG_ALIASES[hex]) hex = BG_ALIASES[hex];
  const hit = ICON_PALETTE.find(p => p.bg && p.bg.toLowerCase() === hex);
  if (hit) return { bg: hit.bg, color: hit.color };
  return { bg: hex, color: '#ffffff' };
}

export function normalizeHex(value, fallback = DEFAULT_ICON_BG) {
  if (isTransparentBg(value)) return fallback;
  const v = String(value).trim();
  let hex = v.startsWith('#') ? v : `#${v}`;
  const alias = BG_ALIASES[hex.toLowerCase()];
  return alias || hex;
}
